import React from "react";
import { propTypes, withFormsy } from "formsy-react";
import ErrorLabel from "../../../common/errorLabel";
import Tooltip from "../../../common/tooltip";

class CheckBox extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  componentDidMount() {
    if (!this.props.getValue()) {
      this.props.setValue(false);
    }
  }

  changeValue(event) {
    this.props.setValue(event.target.checked);
  }

  render() {
    const value = this.props.getValue();
    const errorMessage = this.props.getErrorMessage();
    const { name, label, formData, disableFields, description } = this.props;
    return (
      <div className="form-group">
        <div className="checkbox">
          <label htmlFor={name}>
            <input
              type="checkbox"
              onChange={this.changeValue}
              id={name}
              disabled={disableFields}
              checked={formData[name] || Boolean(value) || false}
            />
            <span className={`lbl ${formData[name] ? "checked" : ""}`}>
              {label}
            </span>{" "}
            {description && (
              <span className="bold">
                <Tooltip message={description} position={"bottom"}>
                  (?)
                </Tooltip>
              </span>
            )}
          </label>
        </div>
        <ErrorLabel message={errorMessage ? errorMessage: ""} />
      </div>
    );
  }
}

CheckBox.propTypes = {
  ...propTypes
};

export default withFormsy(CheckBox);



// WEBPACK FOOTER //
// ./src/components/discover/common/controls/CheckBox.js